export function shouldShowAppUpdatePrompt(args) {
    const { debounce_ms, dismiss_cooldown_ms, dismissedTimestamp, newVersionAvailableTimestamp, now } = args;
    return (newVersionAvailableTimestamp > 0 &&
        (dismissedTimestamp === 0 || dismissedTimestamp + dismiss_cooldown_ms < now) &&
        now - newVersionAvailableTimestamp > debounce_ms);
}
